import React, { Component } from 'react';
import {
  Modal,
  ModalHeader,
  ModalClose,
  ModalBody,
  ModalFooter
} from 'react-modal-bootstrap';
import PropTypes from 'prop-types';
import SubstitutionOptionCard from './SubstitutionOptionCard';
require('./SubstitutionOptionsModal.scss');

class SubstitutionOptionsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProduct: props.originalProduct
    };
  }

  handleSubstitution = () => {
    const { onSelect, onClose } = this.props;
    const { selectedProduct } = this.state;

    onSelect(selectedProduct);
    onClose();
  }

  handleOptionSelection = (selectedProduct) => {
    this.setState({
      selectedProduct
    });
  }

  render() {
    const {
      show: showModal,
      onClose,
      substituteList,
      originalProduct,
      showSimilarProducts
    } = this.props;
    const { selectedProduct } = this.state;

    return (
      <div className="SubstitutionOptionsModal">
        <Modal isOpen={showModal} onRequestHide={onClose} backdrop={true}>
          <ModalHeader closeButton={true}>
            <div className="headerSection">
              <div className="modalTitle">{showSimilarProducts ? 'Available Similar Products' : 'Available alternatives'}</div>
              {
                showSimilarProducts ?
                  <div className="compositionInfo">
                    <div className="generalDisclaimer">
                      <img src={require('@images/disclaimer_leaf.svg')} /><span className="title">Used in similar health conditions </span>
                    </div>
                    <div className="compositionDisclaimer">
                      <img src={require('@images/disclaimer_warning.svg')} /><span className="title">Composition is not same but key ingredients are same </span>
                    </div>
                  </div>
                  :
                  <div>
                    {
                      Boolean(originalProduct.composition) && (<div className="compositionInfo">
                        <span className="title">Composition: </span>
                        {originalProduct.composition}
                      </div>)
                    }
                  </div>
              }
            </div>
            <ModalClose onClick={onClose} />
          </ModalHeader>
          <ModalBody>
            <SubstitutionOptionCard
              variantList={[originalProduct]}
              selectedProduct={selectedProduct}
              onSelect={this.handleOptionSelection}
              isOriginalProduct={true}
            />
            <div className="substituteOptionList">
              {substituteList.map((variantList, index) => (
                <SubstitutionOptionCard
                  key={index}
                  variantList={variantList}
                  selectedProduct={selectedProduct}
                  onSelect={this.handleOptionSelection}
                />
              ))}
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="selectBtn" onClick={this.handleSubstitution}>SUBMIT</button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

SubstitutionOptionsModal.propTypes = {
  show: PropTypes.bool.isRequired,
  originalProduct: PropTypes.object.isRequired,
  substituteList: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  showSimilarProducts: PropTypes.bool,
};

export default SubstitutionOptionsModal;
